import {
    fetchPartner,
    fetchPartners,
    postAddRelation,
    postRemoveRelation,
    patchPartner
} from '@/api/partners';
import {
    fetchApplications,
    fetchApplication,
    rejectApplication as reject,
    approveApplication as approve
} from '@/api/applications';
import { fetchAdministrators } from '@/api/users';
import { fetchTransactions, patchTransaction, fetchTransactionsSums } from '@/api/transactions';
import { fetchCommissions, postCommission } from '@/api/commissions';
import { postInvite } from '@/api/partnerInvitations';
import { patchCommission, removeCommission } from '@/api/commissions';
import { impersonatePartner as apiImpersonatePartner } from '@/api/auth';
import { fetchAffiliates as apiFetchAffiliates } from '@/api/affiliates';
import { impersonatePartner as storeImpersonation } from '@/plugins/impersonatePartner';

export function getPartner(context, payload) {
    return fetchPartner(payload).then((response) => {
        context.commit('setPartner', response.data);
        return response;
    });
}

export function getPartners(context) {
    fetchPartners().then(({ data }) => {
        context.commit('setPartners', data);
        context.commit('setPartnersLoaded', true);
    });
}
export function resetPartners(context) {
    context.commit('setPartners', []);
}

export function updatePartner(context, payload) {
    return patchPartner(payload).then((response) => {
        context.commit('updatePartner', response.data);
        return response;
    });
}

export function addRelationToPartner(context, payload) {
    return postAddRelation(payload).then((response) => {
        context.commit('updatePartner', response.data);
        return response;
    });
}

export function removeRelationFromPartner(context, payload) {
    return postRemoveRelation(payload).then((response) => {
        context.commit('updatePartner', response.data);
        return response;
    });
}

export function getApplication(_, payload) {
    return fetchApplication(payload);
}

export function getApplications(context) {
    return fetchApplications().then((response) => {
        context.commit('setApplications', response.data);
        context.commit('setApplicationsLoaded', true);
        return response;
    });
}

export function setApplicationPayload(context, payload) {
    context.commit('setApplicationApprove', payload);
}

export function approveApplication(_, payload) {
    return approve(payload);
}

export function rejectApplication(_, payload) {
    return reject(payload);
}

export function getAdministrators(context) {
    fetchAdministrators().then(({ data }) => {
        context.commit('setAdministrators', data);
        context.commit('setAdministratorsLoaded', true);
    });
}

export function getTransactions(context, filters) {
    fetchTransactions(filters).then(({ data }) => {
        context.commit('setTransactions', data);
    });
}

export function getTransactionsSums(context, filters) {
    fetchTransactionsSums(filters).then(({ data }) => {
        context.commit('setTransactionsSums', data);
    });
}

export function initTransactions(context, filters) {
    context.commit('setTransactionsLoading', true);

    Promise.all([getTransactions(context, filters), getTransactionsSums(context, filters)])
        .then(() => {
            context.commit('setTransactionsLoading', false);
        })
        .catch(() => {
            context.commit('setTransactionsLoading', false);
        });
}

export function transactionsLoading(context, isLoading) {
    context.commit('setTransactionsLoading', isLoading);
}

export async function postPartnerInvite(context, payload) {
    return postInvite(payload);
}

export function saveTransaction(context, payload) {
    return patchTransaction(payload).then((response) => {
        context.commit('replaceTransaction', {
            transaction: response.data,
            oldId: payload.oldTransactionId
        });
        return response;
    });
}

export function getCommissions(context, partnerId) {
    fetchCommissions(partnerId).then((response) => {
        context.commit('setCommissions', response.data);
        context.commit('setCommissionsLoaded', true);
        return response;
    });
}
export function saveCommission(context, commission) {
    return patchCommission(commission).then((response) => {
        context.commit('updateCommission', response.data);
        return response;
    });
}
export function deleteCommission(context, payload) {
    return removeCommission(payload.id).then((response) => {
        context.commit('removeCommission', payload);
        return response;
    });
}

export function addCommission(context, commission) {
    postCommission(commission).then((response) => {
        context.commit('addCommission', response.data);
        return response;
    });
}

export function impersonatePartner(context, email) {
    apiImpersonatePartner(email).then((response) => {
        storeImpersonation(response.data);
        clearStateAndReload(context);
    });
}

export function clearStateAndReload(context) {
    context.commit('clearAllState', null, { root: true });
    location.replace('/');
}

export function fetchAffiliates(context, partnerId) {
    return apiFetchAffiliates(partnerId).then((response) => {
        context.commit('setAffiliates', response.data);
        context.commit('setAffiliatesLoaded', true);
    });
}
